import $ from 'jquery';
import { connect } from 'react-redux';
import {
  fillChartFromSurveyHelper,
  requireProviderDocuments,
  updateSurvey,
} from 'store/providers/providerSlice';
import ChartViewer from 'components/Chart/ChartViewer';
import * as ErrorDialog from 'components/ErrorView/ErrorDialog';
import { display } from 'components/ErrorView/ErrorDialog';
import LoadingCircleIndicator from 'components/LoadingCircleIndicator';
import {
  getDateOf,
  IProvider,
  IProviderItemViewWithData,
  IProviders,
} from 'store/providers/providerTypes';
import { addGuideToList } from 'store/siteGuide/SiteGuideSlice';
import { appDispatch, RootState } from 'store/store';
import { requireSurvey, setSurveyViewVersion } from 'store/survey/surveySlice';
import {
  IQuestionTags,
  ISurveyItem,
  ISurveyViewWithData,
  SURVEY_ANALYSE_LINK_DESC_NAME,
} from 'store/survey/surveyTypes';

import { SurveyAnalyseTemplateType } from 'store/survey/surveyTypes';
import { getDomainAndPort } from '../../../../api/Utils';
import i18n from '../../../../i18n';
import { SurveyContainer } from './styles';
import Navigation from '../../../Navigation/Navigation';
import SurveyEditor from './SurveyEditor/SurveyEditor';
import Identification from './SurveyEditor/Identification';
import SurveySettingsViewer from './SurveyEditor/SurveySettingsViewer';
import SurveyVersions from './SurveyEditor/SurveyVersions';
import SurveyAnalyseViewer from './SurveyResponseViewer/SurveyAnalyseViewer';
import CreateAnalyseItem from './SurveyResponseViewer/CreateAnalyseItem';
import SurveyResponseViewer from './SurveyResponseViewer/SurveyResponseViewer';
import ItemManagerModal from '../ItemManagerModal';
import { IComponentProps as IComponentBaseProps } from '../ItemManagerModal';
import { IComponentState as IComponentBaseState } from '../ItemManagerModal';
import { ICompany } from '../../../../store/companies/companiesTypes';
import { getCompanyHandler } from '../../../../store/companies/companiesSlice';
import { IThisUserState } from '../../../../store/thisUser/thisUserSlice';
import {
  isCompanyAdmin,
  isCompanyUser,
  isCompanyOwnerOrSupport,
  isAdvanceAdmin,
} from '../../../../store/companies/companiesUtils';
import { IOpenItem } from '../../../../store/entity/IOpenItem';
import Helmet from 'react-helmet';
import Input from '../../../Input/Input';
import Button from '../../../Button/Button';
import { ChangeEvent } from 'react';
import * as surveyApi from '../../../../api/SurveyApi';
import notify from '../../../Notify';
import { Description } from './SurveyResponseViewer/styles';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../CKEditorField/CKEditorField';
import { englishNumber } from '../../../../utils/number';
import { whitesmoke } from 'utils/style/colors';

const { domainFeatures } = getDomainAndPort();

interface IComponentProps extends IComponentBaseProps {
  provider: IProvider | null;
  company?: ICompany | null;
  analyseSurvey: ISurveyViewWithData;
  providers: IProviders;
  tags: IQuestionTags;
  openItem: IOpenItem;
  survey: ISurveyViewWithData | undefined;
  changeState: (item: string) => void;
  dispatch: (action: any) => any;
  isOpen: boolean;
  showHome: boolean;
  onClose: () => void;
  openNextItem: () => void;
  onMinimize: () => void;
  withFewerOption: boolean;
  filteredResponseId: number;
  extraTagIds: number[];
  extraContext?: string;
  limitRelatedUsers: number[];
  providerItems: { [key: number]: IProviderItemViewWithData };
  providerUserId?: number | undefined;
  thisUser: IThisUserState;
  lastPossibleSubmitTime?: number;
  filteredAnalyseId: number;
  showCorrectAnswers: boolean;
  withoutProviderSurvey: boolean;
  pdpId?: number;
  providerSurveyItem?: IProviderItemViewWithData;
  phase?: string;
}

interface IPatient {
  name: string;
  hospital: string;
  age: string;
  status: string;
}

interface IComponentState extends IComponentBaseState {
  loading: boolean;
  baseDate: Date;
  analyseTemplateItem: IProviderItemViewWithData | undefined;
  triedCompany: boolean;
  searchedPatient: string;
  useId: boolean;
  searchResult?: IPatient[];
  loadingPatient?: boolean;
}

interface IMapStateToProps {
  getDocuments: (itemIds: number[]) => any;
  updateProviderSurvey: (surveyItem: ISurveyItem) => any;
  setCurrentVersion: (surveyId: number, versionID: string) => void;
  addGuideToList: (list: string[]) => void;
  getCompany: (id: number) => Promise<any>;
}

class SurveyManagerModal extends ItemManagerModal<
  IComponentProps & IMapStateToProps,
  IComponentState
> {
  EDIT_ITEMS = [
    { id: 'edit', label: i18n.t('edit', { ns: 'modals' }), order: 3 },
  ];
  SETTINGS_ITEMS = [
    { id: 'settings', label: i18n.t('settings', { ns: 'modals' }), order: 4 },
  ];
  IDENTIFICATION_ITEMS = [
    {
      id: 'identification',
      label: i18n.t('identification', { ns: 'modals' }),
      order: 1.5,
    },
  ];

  REPORT_ITEM = [
    {
      id: 'chart',
      label: i18n.t('chart', { ns: 'modals' }),
      order: 2,
    },
  ];
  ANALYSE_ITEM = [
    {
      id: 'analyse',
      label: i18n.t('analyse', { ns: 'modals' }),
      order: 2.5,
    },
  ];
  OWNER_ITEM = [
    {
      id: 'versions',
      label: i18n.t('versions', { ns: 'modals' }),
      order: 5,
    },
  ];
  PATIENTS_FORM = [
    {
      id: 'patientsForm',
      label: i18n.t('patientsForm', { ns: 'modals' }),
      order: 6,
    },
  ];

  state = {
    loading: true,
    baseDate: getDateOf('Today').toDate(),
    analyseTemplateItem: undefined,
    triedCompany: false,
    searchedPatient: '',
    loadingPatient: false,
    searchResult: undefined as IPatient[] | undefined,
    useId: false,
  };

  // UNSAFE_componentWillMount() {}

  UNSAFE_componentWillReceiveProps(newProps: IComponentProps) {
    appDispatch(
      requireSurvey({
        providerSurveyItemData: newProps.openItem.item.data as ISurveyItem,
      })
    );
  }

  componentDidUpdate(mount?: any) {
    super.componentDidUpdate();
    const survey = this.props.survey;
    if (
      mount !== true &&
      !!survey &&
      survey.isLoading === false &&
      survey.isValid === false
    ) {
      ErrorDialog.display(survey.err);
      this.props.onClose();
      ($(this.refs.modal) as any).modal('close');
    }

    const foundAnalysis = this.props.openItem.item.data.itemLinks.find(
      (it) => it.description === SURVEY_ANALYSE_LINK_DESC_NAME
    );
    if (foundAnalysis) {
      const foundAnalysisItem =
        this.props.providerItems[foundAnalysis.destinationItemId];
      if (!foundAnalysisItem)
        this.props
          .getDocuments([foundAnalysis.destinationItemId])
          ?.then((data: any) => {
            const items = data.items;

            if (items?.length > 0 && items?.[0]?.surveyId) {
              appDispatch(requireSurvey({ providerSurveyItemData: items[0] }));
            }
          });
      else if (!this.props.analyseSurvey) {
        appDispatch(
          requireSurvey({
            providerSurveyItemData: foundAnalysisItem.data as ISurveyItem,
          })
        );
      }
    }

    if (!this.props.company && this.props.provider && !this.state.triedCompany)
      if (
        (this.props.openItem.item.data as ISurveyItem).instanceType ===
          'User' ||
        Object.values(this.props.survey?.data?.questionMap || {}).find(
          (q: any) =>
            q.data.fillPermissionSchemeList?.length ||
            q.data.reportPermissionSchemeList?.length
        ) ||
        this.props.openItem.item.data.tags.find(
          (it) => it.text === 'conf_search'
        )
      )
        this.props
          .getCompany(this.props.provider.managingCompanyId as number)
          .finally(() => {
            this.setState({ triedCompany: true });
          });
  }

  fillChart(item: any, survey: any) {
    return fillChartFromSurveyHelper(item, survey);
  }

  componentDidMount() {
    super.componentDidMount();
    appDispatch(
      requireSurvey({
        providerSurveyItemData: this.props.openItem.item.data as ISurveyItem,
        forceReload: true,
      })
    )
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err: any) => {
        display(err);
      });
    const isSupportChecklist = this.props.openItem.item.data.id === 86683;
    const isIndicator = this.props.openItem.item.data.tags.find(
      (it) => it.text === 'شاخص'
    );
    const isAccredit = this.props.openItem.item.data.tags.find(
      (it) => it.text === 'خودارزیابی' || it.text === 'ممیزی'
    );
    if (isSupportChecklist) {
      this.props.addGuideToList([
        'ثبت درخواست پشتیبانی',
        'پیگیری درخواست پشتیبانی',
      ]);
    } else if (isIndicator) {
      this.props.addGuideToList([
        'indicator-fill',
        'indicator-report',
        'indicator-analyse',
      ]);
    } else if (!isAccredit) {
      this.props.addGuideToList(['fill-checklist', 'checklist-report']);
    }
    const analyseTemplateItem = Object.values(this.props.providerItems).find(
      (it) => {
        return (
          !it.data.dadId &&
          it.data.type === 'survey' &&
          it.data.templateType === SurveyAnalyseTemplateType
        );
      }
    );
    this.setState({ analyseTemplateItem: analyseTemplateItem });
  }

  handleSetVersion = (versionId: string) => {
    this.props.setCurrentVersion(
      this.props?.survey?.data?.id as number,
      versionId
    );
  };

  handleSearchPatient = (e: any) => {
    e.preventDefault();
    const reportToken = this.props.survey?.data.fields.find(
      (it) => it.name === 'reportToken'
    )?.value;
    this.setState({ loadingPatient: true });
    const questionId = this.state.useId ? '71229099797619' : '673919120414455';
    surveyApi
      .analyseList(
        {} as any,
        {
          filters: [
            {
              field: 'instance',
              values: [this.props.openItem.item.data.id],
              type: 'termFilter',
            },
            {
              type: 'generalTermFilter',
              query: `allAnswers:${questionId}$$*${englishNumber(this.state.searchedPatient.trim().replace(/\s+/, '\\ '))}*`,
              field: 'allAnswers',
            },
          ],
        },
        reportToken,
        undefined,
        undefined,
        undefined,
        6
      )
      .then((result) => {
        if (result.status === 200) {
          const patients: IPatient[] = result.data.response.map((it) => {
            const patient: IPatient = {
              name: '',
              hospital: '',
              age: '',
              status: '',
            };
            patient.name = it.surveyAnswerList.find(
              (it) => it.questionId === 673919120414455
            )?.value;
            patient.hospital = it.surveyAnswerList.find(
              (it) => it.questionId === 176994938309915
            )?.value;
            patient.age = it.surveyAnswerList.find(
              (it) => it.questionId === 795723136164309
            )?.value;
            patient.status = it.surveyAnswerList.find(
              (it) => it.questionId === 47609625959311
            )?.value;
            return patient;
          });
          this.setState({ searchResult: patients });
        } else {
          notify('خطا در دریافت اطلاعات. لطف دقایقی دیگر امتحان کنید', 'error');
        }
      })
      .catch(() => {
        notify('خطا در دریافت اطلاعات. لطف دقایقی دیگر امتحان کنید', 'error');
      })
      .finally(() => {
        this.setState({ loadingPatient: false });
      });
  };

  renderChild() {
    const {
      tags,
      survey,
      onClose,
      onMinimize,
      dispatch,
      openItem,
      changeState,
      withoutProviderSurvey,
      providerUserId,
      thisUser,
      filteredResponseId,
      filteredAnalyseId,
      extraTagIds,
      extraContext,
      lastPossibleSubmitTime,
      showCorrectAnswers,
      showHome,
      company,
      providerItems,
      analyseSurvey,
      provider,
      updateProviderSurvey,
      providers,
      showAnimation,
      phase,
    } = this.props;
    const params = new URLSearchParams(window.location.search);
    const finalFilteredResponseId =
      filteredResponseId || Number(params.get('filteredResponseId')) || null;
    const finalFilteredAnalyseId =
      filteredAnalyseId || Number(params.get('filteredAnalyseId')) || null;
    const isOwner =
      (company && isCompanyOwnerOrSupport(thisUser, company)) ||
      providerUserId === Number(thisUser.userId);
    const isAdmin = company && isCompanyAdmin(thisUser, company);

    const currentItemData =
      this.props.providerSurveyItem?.data || openItem.item.data;
    const filledOpenItem = {
      status: openItem.status,
      item: {
        data: currentItemData,
      },
    };

    const isNotifGroupEditor =
      !filledOpenItem?.item?.data?.editToken &&
      // filledOpenItem?.item?.data?.changeDataToken &&
      survey?.data?.allowEditNotifGroupMembersTo?.includes(
        Number(thisUser.userId)
      );
    if (
      survey === undefined ||
      !survey?.data ||
      this.state.loading ||
      !provider
    ) {
      return <LoadingCircleIndicator />;
    }

    const surveyType = survey.data.surveyType;

    let SURVEY_ITEMS = [];
    const searchPatientsAvailable = filledOpenItem.item.data.tags.find(
      (it) => it.text === 'conf_search'
    );

    let readOnlyQuestions = false;
    if (surveyType !== 'Bank') {
      SURVEY_ITEMS.unshift(
        ...[
          {
            id: 'responses',
            label: i18n.t('responses', { ns: 'modals' }),
            order: 1,
          },
        ]
      );
    } else {
      if (filledOpenItem.status !== 'edit') {
        changeState('edit');
      }
      if (!filledOpenItem.item.data.editToken) readOnlyQuestions = true;
    }

    if (filledOpenItem.item.data.reportToken && surveyType !== 'Bank') {
      SURVEY_ITEMS.unshift(...this.REPORT_ITEM);
    }

    const isIndicator = filledOpenItem.item.data.tags.find(
      (it) => it.text === 'شاخص'
    );
    const hasIdentification = this.props.openItem.item.data.tags.find(
      (it) => it.text === 'شاخص' && it.type === 'Identification'
    );
    const haveAnalyse = filledOpenItem.item.data.tags.find(
      (it) => it.text === 'شاخص' || it.text === 'دارای تحلیل'
    );
    if (filledOpenItem.item.data.editToken && (!hasIdentification || isOwner)) {
      SURVEY_ITEMS.unshift(...this.EDIT_ITEMS);
    }
    if (
      (filledOpenItem.item.data.editToken || isNotifGroupEditor) &&
      surveyType !== 'Exam' &&
      surveyType !== 'Bank' &&
      (!hasIdentification || isOwner)
    ) {
      SURVEY_ITEMS.unshift(...this.SETTINGS_ITEMS);
    }
    if (
      filledOpenItem.item.data.tags.find((it) => it.type === 'Identification')
    )
      SURVEY_ITEMS.unshift(...this.IDENTIFICATION_ITEMS);

    const foundAnalysis = this.props.openItem.item.data.itemLinks.find(
      (it) => it.description === SURVEY_ANALYSE_LINK_DESC_NAME
    );
    let foundAnalysisItem;
    if (foundAnalysis) {
      foundAnalysisItem = providerItems[foundAnalysis.destinationItemId];
    }
    if (
      (this.state.analyseTemplateItem &&
        filledOpenItem.item.data.editToken &&
        haveAnalyse &&
        !isIndicator) ||
      foundAnalysisItem
    ) {
      SURVEY_ITEMS.unshift(...this.ANALYSE_ITEM);
    }
    if (
      filledOpenItem.item.data.editToken &&
      (isOwner ||
        (isAdmin &&
          (domainFeatures?.allowManageChecklistToUser ||
            isAdvanceAdmin(thisUser, company)) &&
          !isIndicator)) &&
      surveyType !== 'Bank'
    ) {
      SURVEY_ITEMS.unshift(...this.OWNER_ITEM);
    }
    let allowShowForm = true;
    if (searchPatientsAvailable) {
      allowShowForm = !!company && (isCompanyUser(thisUser, company) || false);
      if (allowShowForm) SURVEY_ITEMS.unshift(...this.PATIENTS_FORM);
      else SURVEY_ITEMS = this.PATIENTS_FORM;
    }
    SURVEY_ITEMS = SURVEY_ITEMS.sort((a, b) => b.order - a.order);
    // @todo checkout selectedPdpId
    const questionBankFolder = company?.pdpPanels?.find(
      (companyPdp) => companyPdp.id === this.props.pdpId
    )?.properties?.questionBankFolder;
    const activeVersion = survey.data.currentVersion;
    const versions = filledOpenItem.item.data.reportToken
      ? Object.values(survey.data.versions)
          .sort(
            (a, b) =>
              (b?.versionInfo?.creationDate || 0) -
              (a?.versionInfo?.creationDate || 0)
          )
          .reduce((list: { value: string; label: string }[], item) => {
            list.push({
              value: item?.versionInfo?.versionId || '',
              label:
                (item?.versionInfo?.versionTitle || '') +
                (activeVersion === item?.versionInfo?.versionId
                  ? ` - ${i18n.t('activeVersion', { ns: 'modals' })}`
                  : ''),
            });
            return list;
          }, [])
      : undefined;
    const currentVersion = survey.viewingVersion;
    const foundMyResponse = Object.values(
      this.props.survey?.data.responseMap || {}
    ).find((it) => {
      return (
        it.userId?.toString() === thisUser.userId &&
        !filledOpenItem?.item?.data?.reportToken &&
        !it.deleted
      );
    });
    let lastPossibleSubmitTimeCounter = lastPossibleSubmitTime;
    if (
      this.props.survey?.data?.fillDurationInMinutes &&
      foundMyResponse?.submitDate
    ) {
      lastPossibleSubmitTimeCounter = Math.min(
        lastPossibleSubmitTimeCounter || Number.MAX_VALUE,
        foundMyResponse.submitDate +
          this.props.survey.data?.fillDurationInMinutes * 60_000
      );
    }
    const hasSubmitLink = this.props.survey?.data.fields.find(
      (it) => it.name === 'conf_submitFormLink'
    )?.value;
    const emptyMessage = this.props.survey?.data.fields.find(
      (it) => it.name === 'conf_emptyMessage'
    )?.value;
    return (
      <SurveyContainer isOpen={this.props.isOpen} showAnimation={showAnimation}>
        <Helmet>
          <title>{survey.data.name}</title>
        </Helmet>
        <Navigation
          items={SURVEY_ITEMS}
          onClose={onClose}
          showHome={showHome}
          onMinimize={onMinimize}
          onSelect={changeState}
          defaultTab={filledOpenItem.status}
          showItems={SURVEY_ITEMS?.length > 1}
          title={
            survey.data.name +
            (extraContext && !survey.data.name.includes(extraContext)
              ? ` (${extraContext})`
              : '')
          }
          versionItems={versions}
          currentVersion={currentVersion}
          setVersion={this.handleSetVersion}
          timerDue={lastPossibleSubmitTimeCounter}
        />
        {filledOpenItem.status === 'patientsForm' ||
        ((!company || !isCompanyUser(thisUser, company)) &&
          searchPatientsAvailable) ? (
          <div
            className="flex flex-col mx-3 my-5"
            style={{ height: 'calc(100vh - 120px)' }}
          >
            {this.props.survey?.data?.description && (
              <Description style={{ padding: '1rem ', boxShadow: 'none' }}>
                <div style={{ flexGrow: 1 }}>
                  <CKEditorField
                    // editor={ClassicEditor}
                    data={this.props.survey.data?.description.replace(
                      /\n/g,
                      '<br>'
                    )}
                    disabled={true}
                    dir="rtl"
                    config={CKEditorReadOnlyConfig}
                  />
                </div>
                {/*{surveyDescription}*/}
              </Description>
            )}
            <div>
              <Input
                id={'searchByName'}
                type="radio"
                checked={!this.state.useId}
                label="جستجو با نام"
                onClick={() => {
                  this.setState({ useId: false, searchedPatient: '' });
                }}
              />
              <Input
                id={'searchById'}
                type="radio"
                checked={this.state.useId}
                label="جستجو با کد ملی"
                onClick={() => {
                  this.setState({ useId: true, searchedPatient: '' });
                }}
              />
            </div>
            <div className="flex flex-wrap jutstify-between">
              <form
                onSubmit={this.handleSearchPatient}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '10px',
                  flexWrap: 'wrap',
                  maxWidth: '500px',
                  margin: 'auto',
                }}
              >
                <Input
                  id="patientsInformation"
                  label={
                    this.state.useId
                      ? 'کد ملی فرد مورد نظر'
                      : 'نام و نام خانوادگی فرد مورد نظر'
                  }
                  type="text"
                  wrapperStyle={{ flex: 1 }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    this.setState({ searchedPatient: e.target.value })
                  }
                  value={this.state.searchedPatient}
                />
                <Button
                  type="submit"
                  color={'blue'}
                  loading={this.state.loadingPatient}
                  disabled={(this.state.searchedPatient?.length ?? 0) < 3}
                >
                  جستجوی مصدوم
                </Button>
              </form>
            </div>
            <div
              className="flex flex-col gap-3 flex-1 overflow-auto items-strech"
              style={{ maxWidth: '500px', margin: ' 0 auto' }}
            >
              {(this.state.searchResult?.length || 0) <= 4 &&
                this.state.searchResult?.map((it, index) => {
                  return (
                    <div
                      className="flex gap-2 flex-wrap justify-center flex-col "
                      key={index}
                      style={{
                        padding: '1rem',
                        border: '1px solid lightgray',
                        borderRadius: '1rem',
                        background: whitesmoke,
                      }}
                    >
                      <div className="flex ">
                        <div
                          style={{
                            width: '100px',
                            textAlign: 'start',
                            fontWeight: 'bold',
                          }}
                        >
                          نام مصدوم
                        </div>
                        <div style={{ textAlign: 'start' }}>{it.name}</div>
                      </div>
                      <div className="flex ">
                        <div
                          style={{
                            width: '100px',
                            textAlign: 'start',
                            fontWeight: 'bold',
                          }}
                        >
                          سن
                        </div>
                        <div style={{ textAlign: 'start' }}>{it.age}</div>
                      </div>
                      <div className="flex ">
                        <div
                          style={{
                            width: '100px',
                            textAlign: 'start',
                            fontWeight: 'bold',
                          }}
                        >
                          بیمارستان پذیرش شده{' '}
                        </div>
                        <div style={{ textAlign: 'start' }}>{it.hospital}</div>
                      </div>
                      <div className="flex ">
                        <div
                          style={{
                            width: '100px',
                            textAlign: 'start',
                            fontWeight: 'bold',
                          }}
                        >
                          وضعیت{' '}
                        </div>
                        <div style={{ textAlign: 'start' }}> {it.status}</div>
                      </div>
                    </div>
                  );
                })}
              {this.state.searchResult?.length === 0 && emptyMessage && (
                <div className="flex items-center justify-center w-full h-full flex-col">
                  <div>{emptyMessage}</div>
                  {hasSubmitLink && (
                    <Button
                      color="green"
                      onClick={() => {
                        window.open(hasSubmitLink, '_blank');
                      }}
                    >
                      فرم ثبت اطلاعات
                    </Button>
                  )}
                </div>
              )}
              {(this.state.searchResult?.length || 0) > 4 && (
                <div className="flex items-center justify-center w-full h-full">
                  بیش از ۵ نفر با این اطلاعات یافت شدند لطفا نام فرد را به صورت
                  کامل بنویسید
                </div>
              )}
            </div>
          </div>
        ) : filledOpenItem.status === 'edit' ? (
          <SurveyEditor
            survey={survey}
            providerSurvey={filledOpenItem.item}
            tags={tags}
            dispatch={dispatch}
            company={company as ICompany}
            analyseSurvey={analyseSurvey}
            analyseProviderSurvey={foundAnalysisItem?.data as ISurveyItem}
            providers={providers}
            questionBankFolder={questionBankFolder}
            readOnly={readOnlyQuestions}
            isOwnerOrSupport={isOwner}
          />
        ) : filledOpenItem.status === 'identification' ? (
          <Identification
            item={filledOpenItem.item}
            updateItem={updateProviderSurvey}
            survey={survey}
            tags={tags}
            company={company}
            analyseItem={foundAnalysisItem}
            analyseSurvey={analyseSurvey}
            templateItem={this.state.analyseTemplateItem}
          />
        ) : filledOpenItem.status === 'settings' ? (
          <SurveySettingsViewer
            item={filledOpenItem.item}
            survey={survey}
            allTags={tags}
            withoutProviderSurvey={withoutProviderSurvey || isNotifGroupEditor}
            onlyEditNotifGroups={isNotifGroupEditor}
          />
        ) : filledOpenItem.status === 'versions' ? (
          <SurveyVersions item={filledOpenItem.item} survey={survey.data} />
        ) : (
          <></>
        )}
        {['chart', 'analyse', 'responses', 'identification'].includes(
          filledOpenItem.status
        ) && (
          <>
            {SURVEY_ITEMS.find((it) => it.id === 'chart') && (
              <span
                style={{
                  display:
                    filledOpenItem.status === 'chart' ? undefined : 'none',
                }}
              >
                <ChartViewer
                  surveyId={this.props?.survey?.data.id}
                  surveyItem={filledOpenItem.item.data}
                  baseDate={this.state.baseDate}
                  onChangeBaseDate={(baseDate: any) =>
                    this.setState({ baseDate })
                  }
                  extraTagIds={extraTagIds}
                  extraContext={extraContext}
                />
              </span>
            )}
            {SURVEY_ITEMS.find((it) => it.id === 'analyse') &&
              filledOpenItem.status !== 'responses' && (
                <span
                  style={{
                    display:
                      filledOpenItem.status === 'analyse' ? undefined : 'none',
                  }}
                >
                  {foundAnalysisItem ? (
                    analyseSurvey && analyseSurvey?.data ? (
                      <SurveyAnalyseViewer
                        surveyItem={{ data: filledOpenItem.item.data }}
                        filteredResponseId={finalFilteredAnalyseId}
                        analyseItem={foundAnalysisItem}
                      />
                    ) : (
                      <LoadingCircleIndicator />
                    )
                  ) : (
                    <CreateAnalyseItem
                      surveyItem={filledOpenItem.item.data}
                      templateItem={this.state.analyseTemplateItem}
                      provider={provider}
                    />
                  )}
                </span>
              )}
            {filledOpenItem.status !== 'analyse' &&
              (allowShowForm || !searchPatientsAvailable) && (
                <SurveyResponseViewer
                  showCorrectAnswers={showCorrectAnswers}
                  surveyItem={filledOpenItem.item}
                  filteredResponseId={finalFilteredResponseId}
                  extraTagIds={extraTagIds}
                  lastPossibleSubmitTime={lastPossibleSubmitTime}
                  openNextItem={this.props.openNextItem}
                  visible={filledOpenItem.status === 'responses'}
                  limitRelatedUsers={this.props.limitRelatedUsers}
                  filteredQuestionTagId={
                    openItem?.extraProps?.mandatoryTagIds || []
                  }
                  pdpInfo={{ phase }}
                  surveyType={survey.data.surveyType}
                />
              )}
          </>
        )}{' '}
        {/*{filledOpenItem.status === 'form' && <div>salam salam</div>}*/}
        <div></div>
      </SurveyContainer>
    );
  }
}

const mapStateToProps = (state: RootState, props: IComponentProps) => {
  const surveyId = props.openItem.item.data.surveyId;
  const survey =
    surveyId !== undefined ? state.survey?.data?.[surveyId] : undefined;
  const tags =
    state.providers?.tags?.[props.openItem.item.data.providerId]?.data || {};

  const providerId = props.openItem.item.data.providerId;
  const provider = state.providers.map[providerId]?.data;
  const providerUserId = provider?.user;
  const managingCompanyId = provider?.managingCompanyId;
  const company = managingCompanyId
    ? state.companies.data[managingCompanyId]
    : undefined;

  const providerItems = state.providers.items[providerId]?.items;
  const providerSurveyItem = providerItems?.[props.openItem.item.data.id];

  const currentItemData = providerSurveyItem?.data || props.openItem.item.data;
  const foundAnalysis = currentItemData.itemLinks?.find(
    (it) => it.description === SURVEY_ANALYSE_LINK_DESC_NAME
  );

  let analyseSurvey = undefined;
  if (foundAnalysis) {
    const foundAnalysisItem = providerItems?.[foundAnalysis.destinationItemId];
    if (foundAnalysisItem?.data?.surveyId) {
      analyseSurvey = state.survey?.data[foundAnalysisItem.data.surveyId];
    }
  }

  return {
    survey,
    analyseSurvey,
    tags,
    providerUserId,
    thisUser: state.thisUser,
    company,
    providerItems,
    provider,
    store: state,
    providers: state.providers,
    providerSurveyItem,
  };
};

const mapDispatchToProps = (dispatch: (action: any) => any) => ({
  setCurrentVersion: (surveyId: number, version: string) => {
    return dispatch(setSurveyViewVersion({ surveyId, versionId: version }));
  },
  getDocuments: (itemIds: number[]) => {
    return dispatch(requireProviderDocuments({ documentIds: itemIds }));
  },
  updateProviderSurvey: (surveyItem: ISurveyItem) => {
    return dispatch(updateSurvey({ item: surveyItem }));
  },
  addGuideToList: (key: string | string[]) => {
    return dispatch(addGuideToList(key));
  },
  getCompany: (companyId: number) => {
    return dispatch(
      getCompanyHandler({
        companyId,
        templateStub: false,
        companyStub: false,
        projectStub: false,
        taskStub: false,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyManagerModal);
